import React, { useState, useEffect, useRef } from "react";
import "./SelectInput.scss";

// @ts-ignore
const CustomSelect = ({ options, label, onSelect }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredOptions, setFilteredOptions] = useState(options);
    const [selectedOption, setSelectedOption] = useState(null);
    const dropdownRef = useRef(null);

    useEffect(() => {
        setFilteredOptions(
            options.filter((option: { NOMBRE: string; }) =>
                option.NOMBRE.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    }, [searchTerm, options]);

    const handleSelect = (option: any) => {
        setSelectedOption(option);
        setIsOpen(false);
        setSearchTerm(""); // Resetea el término de búsqueda después de seleccionar
        onSelect(option); // Llama la función onSelect pasada desde el componente padre
    };

    // Cierra el dropdown al hacer clic fuera
    useEffect(() => {
        const handleClickOutside = (event: { target: any; }) => {
            // @ts-ignore
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="custom-select" ref={dropdownRef}>
            <label>{label}</label>
            <div
                className="select-input"
                onClick={() => setIsOpen((prev) => !prev)}
            >
                { //@ts-ignore
                    selectedOption ? selectedOption.NOMBRE : "Seleccione una opción"}
            </div>
            {isOpen && (
                <div className="dropdown">
                    <input
                        type="text"
                        placeholder="Buscar..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input-route"
                    />
                    <ul className="options-list">
                        {filteredOptions.map((option: any, index: number) => (
                            <li
                                key={index}
                                onClick={() => handleSelect(option)}
                                className="option-item"
                            >
                                {option.NOMBRE}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default CustomSelect;
